<template>
  <div
    class="BasePlaceholder"
    :style="computedHeight">
    <div
      class="BasePlaceholder_Block"
      :style="computedWidth"
      v-for="n in blocks"
      :key="'placeholder-' + n">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasePlaceholder',

  props: {
    width:  { type: String, default: '100%' },
    height: { type: String, default: '24px' },
    blocks: { type: Number, default: 1 },
  },

  computed: {
    computedWidth() {
      return { width: this.width };
    },

    computedHeight() {
      return { height: this.height };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BasePlaceholder {
  white-space: nowrap;
}

.BasePlaceholder_Block {
  display: inline-block;
  height: 100%;
  border-radius: $radius;
  background-color: $grey;
}

.BasePlaceholder_Block + .BasePlaceholder_Block {
  margin-left: 8px;
}
</style>
